import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

export const easeInOutSine = (x) => {
  return -(Math.cos(Math.PI * x) - 1) / 2
}

export const ARROW_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currentColor" d="M335 408.1C330.3 404.3 328 398.2 328 392s2.344-12.28 7.031-16.97L430.1 280H24C10.75 280 0 269.2 0 255.1C0 242.7 10.75 232 24 232h406.1l-95.03-95.03c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0l136 136c9.375 9.375 9.375 24.56 0 33.94l-136 136C359.6 418.3 344.4 418.3 335 408.1z"/></svg>`

export class MangaSlider {
  constructor() {
    this.thumbSliderEl = document.getElementById('js-manga-thumb-slider')
    this.modalSliderEl = document.querySelectorAll('.js-manga-modal-slider')
    if (!this.thumbSliderEl || this.modalSliderEl.length === 0) return

    this.autoplayDelay = 4000
    this.timeout = null
    this.isMouseOver = false

    this.initThumbSlider()
  }
  initThumbSlider() {
    this.thumbSliderEl.classList.add('keen-slider')
    this.slides = [...this.thumbSliderEl.children]
    this.slidesLength = this.slides.length
    this.slides.forEach((slide) => slide.classList.add('keen-slider__slide'))

    this.thumbSlider = new KeenSlider(this.thumbSliderEl, {
      loop: true,
      renderMode: 'custom',
      mode: 'snap',
      defaultAnimation: {
        duration: 1500,
      },
      created: (s) => {
        this.updateActiveSlide(s)
        if (this.slidesLength <= 1) return
        this.createNav(s)
        this.nextTimeout(s)
      },
      detailsChanged: (s) => this.updateSlides(s),
      slideChanged: (s) => this.updateActiveSlide(s),
      dragStarted: () => this.clearNextTimeout(),
      animationEnded: (s) => this.nextTimeout(s),
      updated: (s) => this.nextTimeout(s),
    })
  }
  createNav(s) {
    const nav = document.createElement('div')
    nav.className = 'p-index_manga__slider__nav'

    // -prev ボタンを作成して追加
    nav.appendChild(
      this.createNavButton('prev', '前へ', () => {
        s.prev()
        this.clearNextTimeout()
      }),
    )
    // -next ボタンを作成して追加
    nav.appendChild(
      this.createNavButton('next', '次へ', () => {
        s.next()
        this.clearNextTimeout()
      }),
    )

    const wrapper = s.container.parentNode
    wrapper.appendChild(nav)

    // ホバー中は自動再生を停止する
    wrapper.addEventListener('mouseenter', () => {
      this.isMouseOver = true
      this.clearNextTimeout()
    })
    wrapper.addEventListener('mouseleave', () => {
      this.isMouseOver = false
      this.nextTimeout(s)
    })
  }
  createNavButton(direction, label, onClick) {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = `p-index_manga__slider__nav__button -${direction}`
    button.setAttribute('aria-label', label)
    button.innerHTML = ARROW_SVG
    button.addEventListener('click', onClick)
    return button
  }
  updateSlides(s) {
    s.slides.forEach((slide, i) => {
      const slideCard = slide.children[0]
      if (!slideCard) return
      let { portion, distance } = s.track.details.slides[i]
      if (distance < -Math.floor(this.slidesLength / 2)) {
        distance += this.slidesLength
      } else if (distance > Math.floor(this.slidesLength / 2)) {
        distance -= this.slidesLength
      }
      let per = 0
      if (distance <= 2 && distance >= 0) {
        per = easeInOutSine(1 - Math.abs(distance - 1))
      } else if (distance >= -2 && distance < 0) {
        per = -easeInOutSine(1 - Math.abs(distance + 1))
      }
      slideCard.style.transform = `scale(${1 - (1 - easeInOutSine(portion)) * 0.38})`
      slide.style.transform = `translate3d(${distance * 90 + per * 5}%,0px,0px)`
    })
  }
  // active なスライドだけを操作できるようにする
  updateActiveSlide(s) {
    const activeIndex = s.track.details.rel
    s.slides.forEach((slide, i) => {
      const isActive = i === activeIndex
      slide.classList.toggle('is-active', isActive)
      slide.inert = !isActive
    })
  }
  nextTimeout(s) {
    this.clearNextTimeout()
    if (this.isMouseOver || this.slidesLength <= 1) return
    this.timeout = setTimeout(() => s.next(), this.autoplayDelay)
  }
  clearNextTimeout() {
    clearTimeout(this.timeout)
    this.timeout = null
  }
}
